import React, { useEffect, useState } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  useMediaQuery,
  CircularProgress,
  Snackbar,
  Alert,
} from "@mui/material";
import CryptoJS from "crypto-js";
import { getDecryptedRefreshToken } from "../../LoginUserDetails.js/LoginUserSavedDetails";
import ApiServices from "../../ApiServices/ApiServices";
import PatientSidebar from "../../../Container/Patient/PatientSidebar/PatientSidebar";
import PatientDashboard from "../../../Components/PatientComponents/PatientDashboard/PatientDashboard";
import PatientRouteAccess from "./PatientRouteAccess";
import BookAppointment from "../../../Components/PatientComponents/BookAppointment/BookAppointment";
import UpdatePatientDocumentsDialog from "../../../Components/PatientComponents/PatientDashboard/UpdatePatientDocumentsDialog";
import UpdateLabReports from "../../../Components/PatientComponents/PatientDashboard/UpdateLabReports";
import UpdateAllergiesDialog from "../../../Components/PatientComponents/PatientDashboard/UpdateAllergiesDialog";
import AllBookedAppointments from "../../../Components/PatientComponents/BookAppointment/AllBookedAppointments";
import AppointmentDetails from "../../../Components/ProviderComponents/AppointmentDetails/AppointmentDetails";
import Exercises from "../../../Components/PatientComponents/Exercises/Exercises";
import AllAppointmentTabs from "../../../Components/PatientComponents/BookAppointment/AllAppointmentTabs";
import ZoomMeeting from "../../../Components/ProviderComponents/AllAppointments/ZoomMeeting";
import AvailableMemberships from "../../../Components/PatientMembership/AvailableMemberships";
import PatientMembershipDetails from "../../../Components/PatientMembership/PatientMembershipDetails";
import ChatSystem from "../../../Components/PatientComponents/ChatSystem/ChatSystem";
import MessagesUser from "../../../Components/ProviderComponents/ChatSystem/MessagesUser";
const PatientRoutes = () => {
  const isLargeScreen = useMediaQuery("(min-width:1441px)");
  const [showDialog, setShowDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const navigate = useNavigate();
  const timeoutDuration = 30 * 60 * 1000;

  useEffect(() => {
    const timeout = setTimeout(() => {
      setShowDialog(true);
    }, timeoutDuration - 1 * 60 * 1000);

    const resetTimeout = () => {
      clearTimeout(timeout);
      setShowDialog(false);
    };

    window.addEventListener("click", resetTimeout);
    window.addEventListener("keypress", resetTimeout);

    return () => {
      clearTimeout(timeout);
      window.removeEventListener("click", resetTimeout);
      window.removeEventListener("keypress", resetTimeout);
    };
  }, [timeoutDuration]);

  const handleLogout = async () => {
    setLoading(true);
    setTimeout(() => {
      setShowDialog(false);
      sessionStorage.clear();
      navigate("/");
      setLoading(false);
    }, 3000);
  };

  const handleContinueSession = () => {
    setLoading(true);
    const RefreshToken = getDecryptedRefreshToken();

    const payload = {
      // user_role: "users",
      client_id: process.env.REACT_APP_CLINTID_ACS_TKN,
      scope: process.env.REACT_APP_PATIENT_SCOPES,
      grant_type: "refresh_token",
      refresh_token: RefreshToken,
    };

    ApiServices.post("/oauth2/default/token", payload, {
      "Content-Type": "application/x-www-form-urlencoded",
    })
      .then((response) => {
        const secretKey = process.env.REACT_APP_SECRET_KEY;
        const encryptedAccessToken = CryptoJS.AES.encrypt(
          response.data.access_token,
          secretKey
        ).toString();
        sessionStorage.setItem("LoginUserAccessToken", encryptedAccessToken);
        const encryptedRefreshToken = CryptoJS.AES.encrypt(
          response.data.refresh_token,
          secretKey
        ).toString();
        sessionStorage.setItem("LoginUserRefreshToken", encryptedRefreshToken);
        setShowDialog(false);
      })
      .catch((error) => {
        if (error !== null) {
          setSnackbarOpen(true);
          setSnackbarMessage("An error occurred during session renewal.");
          // handleLogout();
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  const handleDialogAlwaysOpened = () => {
    setShowDialog(true);
  };

  return (
    <div>
      <PatientSidebar />
      <div
        style={{
          marginLeft: isLargeScreen ? "250px" : "0",
          flexGrow: 1,
          padding: "10px",
        }}
      >
        <Routes>
          <Route path="/dashboard" element={<PatientRouteAccess element={<PatientDashboard />} />}/>
          <Route path="/appointments" element={<PatientRouteAccess element={<BookAppointment />} />}/>
          <Route path="/send-messages" element={<PatientRouteAccess element={<MessagesUser />} />}/>
          <Route path="/all-appointments" element={<PatientRouteAccess element={<AllAppointmentTabs />} />}/>
          {/* <Route path="/all-appointments" element={<PatientRouteAccess element={<AllBookedAppointments />} />}/> */}
          <Route path="/documents" element={<PatientRouteAccess element={<UpdatePatientDocumentsDialog />} />}/>
          <Route path="/lab-reports" element={<PatientRouteAccess element={<UpdateLabReports />} />}/>
          <Route path="/allergies" element={<PatientRouteAccess element={<UpdateAllergiesDialog />} />}/>
          <Route path="/exercises" element={<PatientRouteAccess element={<Exercises />} />}/>
          <Route path="/available-membership" element={<PatientRouteAccess element={<AvailableMemberships />} />}/>
          <Route path="/membership-details/:groupId/:category/:plan_id/:role" element={<PatientRouteAccess element={<PatientMembershipDetails />} />}/>
          <Route path="/appot-data/:uuid/:pid/:eid" element={<PatientRouteAccess element={<AppointmentDetails/>} />}/>
          <Route path="/consultation/:meetid/:pass" element={<PatientRouteAccess element={<ZoomMeeting/>} />}/>
          
          
        </Routes>
      </div>
      <Dialog
        open={showDialog}
        onClose={(event, reason) => {
          if (reason === "backdropClick" || reason === "escapeKeyDown") {
            event.stopPropagation();
          }
        }}
        disableBackdropClick
        disableEscapeKeyDown
      >
        <DialogTitle>Session Expiring</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Your login session is expiring in 5 minutes. Do you want to continue
            or log out now?
          </DialogContentText>
          {loading && <CircularProgress />}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleContinueSession}
            color="primary"
            disabled={loading}
          >
            {loading ? <CircularProgress size={24} /> : "Continue"}
          </Button>
          <Button onClick={handleLogout} color="secondary" disabled={loading}>
            {loading ? <CircularProgress size={24} /> : "Log Out"}
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
      >
        <Alert onClose={handleCloseSnackbar} severity="error">
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default PatientRoutes;
